import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {NewInfluencer, NewInfluencerChanel} from '../../../../models/influencer/new-influencer';
import {CommonConstant, listOrderedPlatforms, platformIconPath, platformIconPathById} from '../../../app.constants';
import {InfluencerService} from '../../../services/influencer/influencer.service';
import {InfluencerGroup} from '../../../../models/influencer-group';
import {ReferenceDataService} from '../../../services/reference-data/reference-data.service';
import {AchooPopupComponent} from '../../../core/achoo-popup/achoo-popup.component';
import {AchooFilterBoxComponent} from '../../../core/achoo-filter-box/achoo-filter-box.component';
import {ModalService} from '../../../services/modal/modal.service';
import {InfluencerSuggestion, InfluencerSuggestionState} from '../../../../models/influencer-suggestion';
import {ErrorTemplate} from '../../../../models/ErrorTemplate';
import {ValidationHandlerService} from '../../../core/validation-handler.service';

@Component({
  selector: 'add-influencer-manually',
  templateUrl: './add-influencer-manually.component.html',
  styleUrls: ['./add-influencer-manually.component.scss']
})
export class AddInfluencerManuallyComponent implements OnInit {

  @Output() closeFragmentAddInfluencerManually = new EventEmitter<any>();
  @Output() errorWhenCreatingNewInfluencer = new EventEmitter<any>();
  @Input() influencerGroup: InfluencerGroup;
  @Input() influencerSuggestion: InfluencerSuggestion;
  @ViewChild('platformList') platformList: AchooFilterBoxComponent;
  @ViewChild('NotificationAfterAddingNewInfluencerSuccess')
  notificationAfterAddingNewInfluencerSuccess: AchooPopupComponent;
  @ViewChild('ConfirmationBeforeExistingNewInfluencerFragment')
  confirmationBeforeExistingNewInfluencerFragment: AchooPopupComponent;
  public newInfluencer: NewInfluencer = new NewInfluencer();
  public influencerChannels: NewInfluencerChanel[] = [];
  public listPlatform: any[] = [];

  public fieldErrors: ErrorTemplate[] = [];

  constructor(private influencerService: InfluencerService,
              private referenceService: ReferenceDataService,
              private validationErrorHandler: ValidationHandlerService,
              private modalService: ModalService) { }

  ngOnInit() {
    listOrderedPlatforms.forEach((channel) => {
      this.listPlatform.push({
        id: channel.id,
        name: channel.name
      });
    });
    // instagram is mandatory and default channel
    const igChannel = new NewInfluencerChanel(platformIconPath.instagram.id);
    igChannel.handle = this.removeAtSign(this.influencerSuggestion.influencerName);
    this.influencerChannels.push(igChannel);
    this.newInfluencer.activeChannels.push(igChannel.platform_id);
  }

  deleteInfluencerProfile(platformId) {
    const deleteChannelIndex = this.influencerChannels.findIndex(channel => channel.platform_id === platformId);
    this.influencerChannels.splice(deleteChannelIndex, 1);
    const deleteActiveChannelIndex = this.newInfluencer.activeChannels.findIndex(ac => ac === platformId);
    this.newInfluencer.activeChannels.splice(deleteActiveChannelIndex, 1);
    this.platformList.updateModel(this.newInfluencer.activeChannels);
  }

  trackInfluencerChannel(index, channel) {
    return index;
  }

  closeAddInfluencerManuallyFragment() {
    this.closeConfirmationPopup();
    this.internalCloseFragment();
  }

  private internalCloseFragment(influencer?: InfluencerSuggestion) {
    this.closeFragmentAddInfluencerManually.emit(influencer);
  }

  addNewInfluencer() {
    const errors = this.influencerService.validateInfluencerData(this.newInfluencer, this.influencerChannels);
    if (errors.length > 0) {
      this.fieldErrors = errors;
      this.validationErrorHandler.shouldDisplayErrors(true);
      this.validationErrorHandler.updateErrors(errors);
      return;
    }

    // Remove the @ sign
    this.influencerSuggestion.influencerName = this.removeAtSign(this.influencerSuggestion.influencerName);
    this.influencerChannels[0].handle = this.removeAtSign(this.influencerChannels[0].handle);

    // show on UI status of adding new influencer
    this.influencerSuggestion.state = InfluencerSuggestionState.PROCESSING;
    this.influencerSuggestion.id = -1;
    this.internalCloseFragment(this.influencerSuggestion);
    this.influencerService.addInfluencerByHandle(this.newInfluencer, this.influencerChannels).subscribe(res => {
      const existingInfluencer = res.data;
      this.newInfluencer.name = existingInfluencer.name;
      this.newInfluencer.country = existingInfluencer.country ? existingInfluencer.country.id : null;
      this.newInfluencer.languages = this.extractLanguages(existingInfluencer.influencerLanguages);
      this.newInfluencer.activeChannels = this.extractActiveChannels(existingInfluencer.influencerChannels);
      this.newInfluencer.status = existingInfluencer.status;
      this.newInfluencer.gender = existingInfluencer.gender;
      this.newInfluencer.email = existingInfluencer.email;
      this.newInfluencer.systemEmail = existingInfluencer.systemEmail;
      this.afterAddingInfluencerSuccess(existingInfluencer);
    }, (err) => {
      let influencerData = Object.assign({}, this.newInfluencer, {
        languages: this.newInfluencer.languages || [CommonConstant.INTERNATIONAL_LANGUAGE]
      });
      if (this.newInfluencer.country) {
        influencerData = Object.assign({}, influencerData, {
          country: this.newInfluencer.country
        });
      }
      this.influencerService.addNewInfluencer(influencerData, this.influencerChannels,
        this.afterAddingInfluencerSuccess.bind(this), this.onErrorOccurred.bind(this));
    });
  }

  private extractLanguages(influencerLanguages) {
    if (Array.isArray(influencerLanguages) && influencerLanguages.length === 0) {
      return [];
    }
    return influencerLanguages.map(il => il.language ? il.language.id : 0);
  }

  private extractActiveChannels(influencerChannels) {
    if (Array.isArray(influencerChannels) && influencerChannels.length === 0) {
      return [];
    }
    return influencerChannels.map(ic => ic.platform_id);
  }

  afterAddingInfluencerSuccess(influencer) {
    this.modalService.open(this.notificationAfterAddingNewInfluencerSuccess, undefined, true);
    this.influencerSuggestion.id = influencer.id;
    this.influencerSuggestion.influencerId = influencer.id;
    this.influencerSuggestion.channels = this.influencerChannels.map(c => ({
      platform_id: c.platform_id,
      handle: c.handle
    }));
    this.influencerSuggestion.influencerName = influencer.domain;
    this.influencerSuggestion.countryCode = influencer.country.code;
    this.influencerSuggestion.state = InfluencerSuggestionState.SINGLE_SUGGESTION;
  }

  onErrorOccurred(err) {
    this.influencerSuggestion.state = InfluencerSuggestionState.ERROR;
    this.errorWhenCreatingNewInfluencer.emit({
      newInfluencer: this.newInfluencer,
      influencerChannels: this.influencerChannels
    });
  }

  get countryList() {
    return this.referenceService.countries;
  }

  get languageList() {
    return this.referenceService.languages;
  }

  get genderError() {
    const genderErr = this.fieldErrors.find(err => err.name === 'newInfluencer.gender');
    return genderErr;
  }

  findChannelNameById(channelId) {
    const channel = platformIconPathById[channelId];
    return channel ? channel.name.toLowerCase() + '-channel' : '';
  }

  getPrefixByPlatform(platformId) {
    const channel = platformIconPathById[platformId];
    return channel ? channel.prefix : '';
  }

  channelFormName(channelId) {
    const channel = platformIconPathById[channelId];
    return channel ? channel.name.toLowerCase() + '.handle' : null;
  }

  onSelectChannel(evt) {
    // keep all already selected channels
    this.influencerChannels = this.influencerChannels.filter(p => this.newInfluencer.activeChannels.indexOf(p.platform_id) >= 0);

    // extract id
    const alreadySelectedChannelIds = this.influencerChannels.map(c => c.platform_id);
    // find list of new added channels
    const newAddedChannels = this.newInfluencer.activeChannels.filter(sc => alreadySelectedChannelIds.indexOf(sc) < 0)
      .map(c => {
        const newChannel = new NewInfluencerChanel(c);
        if (c === platformIconPath.tiktok.id) {
          newChannel.handle = '@';
        }
        return newChannel;
      });

    this.influencerChannels.push(...newAddedChannels);
  }

  onSelectGender(evt) {
    this.fieldErrors = this.fieldErrors.filter(err => err.name !== 'newInfluencer.gender');
  }

  closeConfirmationPopup() {
    this.modalService.close();
  }

  openConfirmationBeforeExisting() {
    this.modalService.openInCenter(this.confirmationBeforeExistingNewInfluencerFragment);
  }

  removeAtSign(influencerItemName) {
    const itemName = influencerItemName ? influencerItemName.toString().trim() : '';
    if (itemName.startsWith('@')) {
      return itemName.substring(1);
    }
    return itemName;
  }

}



// WEBPACK FOOTER //
// ./src/app/main/influencer/add-influencer-manually/add-influencer-manually.component.ts